import styled, { css } from 'styled-components';

import { StyledSwiper } from '@/components/BoutiqueSlider/BoutiqueSlider.styles';
import { Box } from '@/components/Box/Box';
export const Wrapper = styled(Box)`
  min-height: 400px;
  position: relative;
  ${({ theme }) => css`
    padding: 24px 16px;
    ${theme.media.md.up} {
      max-width: ${theme.breakpoints.lg};
      margin: 68px auto;
    }
  `}
`;

export const Container = styled(Box)`
  max-width: 1208px;
  position: relative;
  margin: 0 auto;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: 0 72px;
    }
    .swiper {
      position: unset !important;
      .swiper-button-disabled {
        display: none;
      }
      .swiper-button-next,
      .swiper-button-prev {
        top: 30%;
        background: ${theme.colors.secondaryLightGrey};
        color: ${theme.colors.primaryBlue};
        height: ${theme.spacing(5)};
        width: ${theme.spacing(5)};
        &::after {
          font-size: ${theme.spacing(2.5)};
        }
      }
      .swiper-button-next {
        right: 0;
      }
      .swiper-button-prev {
        left: 0;
      }
    }
  `}
`;

export const SliderSwiper = styled(StyledSwiper)`
  width: 100%;
  ${({ theme }) => css`
    .swiper {
      &-wrapper {
        padding-bottom: 40px;
      }
      &-scrollbar {
        ${theme.media.md.up} {
          background: ${({ theme }) => theme.colors.primaryDark};
        }

        &-drag {
          background: ${({ theme }) => theme.colors.primary};
        }
      }
      &-slide {
        aspect-ratio: 4 / 5;
      }
    }
  `}
`;

export const FullWidthWrapper = styled(Wrapper)`
  margin: 0 auto;
  padding: 0 0 0 16px;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: 47px 0 0 ${theme.spacing(5)};
    }
    .swiper-button-disabled {
      display: none;
    }
    .swiper-button-next,
    .swiper-button-prev {
      top: 50%;
      background: ${theme.colors.shadow2};
      color: ${theme.colors.white};
      height: ${theme.spacing(6)};
      width: ${theme.spacing(6)};
      &::after {
        font-size: ${theme.spacing(2.5)};
      }
    }
    .swiper-button-next {
      right: 50px;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper {
      &-slide {
        aspect-ratio: 3 / 4;
      }
      &-scrollbar {
        ${theme.media.md.up} {
          background: ${({ theme }) => theme.colors.mediumGrey};
          height: 2px;
          bottom: 0;
          width: 50%;
          left: 25%;
        }

        &-drag {
          background: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  `}
`;
